<app-global-loader />
@if (!isLandingRoute()) { <app-toast-container /> }

<div [class.app-shell]="!isAuthRoute()">
  @if (!isAuthRoute()) {
    <app-portal-header [sidebarCollapsed]="sidebarCollapsed()" (menuToggle)="toggleSidebar()" />
  }

  <div [class.portal-layout]="!isAuthRoute()" [class.portal-layout--sidebar-collapsed]="!isAuthRoute() && sidebarCollapsed()">
    @if (!isAuthRoute()) {
      <app-portal-sidebar [collapsed]="sidebarCollapsed()" (expandRequested)="expandSidebar()" />
    }

    <main [class.auth-page-content]="isAuthRoute()" [class.portal-content]="!isAuthRoute()">
      <router-outlet />
    </main>
  </div>

  @if (!isAuthRoute()) {
    <app-portal-footer />
  }
</div>
